package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.invoke
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.zest.insan_360_website.data.Language
import org.zest.insan_360_website.data.page_states.UserPreferences

val toggleSizeBreakpoints = CssStyle {
    base {
        Modifier.fontSize(0.8.cssRem)
    }
    Breakpoint.MD {
        Modifier.fontSize(1.cssRem)
    }
    Breakpoint.LG {
        Modifier.fontSize(1.cssRem)
    }
}

@Composable
fun LanguageToggle(color: Color.Rgb? = null, rightEm: Number = 1, topEm: Number = 1) {
    val isBM = UserPreferences.language == Language.BM
    Row(
        Modifier
            .position(Position.Absolute)
            .right(rightEm.cssRem)
            .top(topEm.cssRem)
            .gap(0.8.cssRem)
            .userSelect(UserSelect.None)
            .then(toggleSizeBreakpoints.toModifier()),
        verticalAlignment = Alignment.CenterVertically
    ) {
        SpanText(
            "BM",
            Modifier
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Bold)
                .color(color?.darkened(0.5f) ?: Colors.Black)
                .opacity(if (isBM) 1f else 0.25f)
                .transition {
                    "opacity" { duration(0.35.s) }
                }
        )
        Box(
            Modifier
                .width(4.4.cssRem)
                .height(2.4.cssRem)
                .padding(0.2.cssRem)
                .backgroundColor(color?.darkened(0.25f) ?: Colors.Black)
                .borderRadius(99.px)
                .onClick {
                    when (UserPreferences.language) {
                        Language.BM -> UserPreferences.setLanguage(Language.EN)
                        Language.EN -> UserPreferences.setLanguage(Language.BM)
                    }
                }
        ) {
            Box(
                Modifier
                    .fillMaxHeight()
                    .fillMaxWidth(50.percent)
                    .backgroundColor(color ?: Colors.White)
                    .borderRadius(99.px)
                    .overflow(Overflow.Clip)
                    .transform { translate(tx = if (!isBM) 2.cssRem else 0.cssRem) }
                    .transition {
                        "transform" { duration(0.35.s) }
                    }
            )
        }
        SpanText(
            "EN",
            Modifier
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Bold)
                .color(color?.darkened(0.5f) ?: Colors.Black)
                .opacity(if (!isBM) 1f else 0.25f)
                .transition {
                    "opacity" { duration(0.35.s) }
                }
        )
    }
}